// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RPFcYssubzY0YMX59OcJ{align-items:center;margin-right:auto;padding:12px 24px 12px 12px;display:flex}.RPFcYssubzY0YMX59OcJ div.f_29m50YqdwjGD6JlFhp{background:var(--action-contained-secondary-normal);border-radius:6px;justify-content:center;align-items:center;height:24px;font-size:12px;font-weight:500;display:flex}.RPFcYssubzY0YMX59OcJ div.f_29m50YqdwjGD6JlFhp:hover{background:var(--action-contained-secondary-hovered)}.RPFcYssubzY0YMX59OcJ .KI7c6xO5DTAcOa2qADfK{color:var(--content-primary-tertiary);font-size:12px;font-weight:500}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RPFcYssubzY0YMX59OcJ`,
	"select": `f_29m50YqdwjGD6JlFhp`,
	"allRowsCount": `KI7c6xO5DTAcOa2qADfK`
};
export default ___CSS_LOADER_EXPORT___;
